const $ = jQuery.noConflict()
class AwardsArchive {
    constructor() {
        this.postsBlock = $('.awards-posts')
        this.postsBlockWrapper = $('.awards-posts__wrapper')
        this.links = '.news-and-awards-hero__post-category, .news-and-awards-hero__category > a, .awards-post__category'
        this.moreBtn = $('.awards-posts__more')
        this.moreBtnWrapper = $('.awards-posts__more-wrapper')
    }
    init() {
        if (!this.postsBlock.length) {
            return
        }
        this.bindEvents()
    }
    bindEvents() {
        // Category link click
        $(document).on('click', this.links, event => {
            event.preventDefault()
            const link = $(event.currentTarget)
            const termId = parseInt(link.attr('data-term-id'))
            this.loadPosts(1, termId, ajax_nonce.nonce)
        })
        // More btn click
        this.moreBtn.on('click', event => {
            event.preventDefault()
            const nextPage = parseInt(this.postsBlockWrapper.attr('data-page'))
            const termId = parseInt(this.postsBlockWrapper.attr('data-term-id'))
            this.loadPosts(nextPage + 1, termId, ajax_nonce.nonce)
        })
    }
    loadPosts(page = 1, termID, nunce) {
        // Load posts
        $.ajax({
            url: WP.ajaxUrl,
            type: 'POST',
            data: {
                action: 'awards_ajax_handler',
                term_id: termID,
                page: page,
                security: nunce
            },
            beforeSend: () => {
                this.setLoading()
            },
            success: result => {
                // Set pagination visibility
                const pagination = result.substr(result.length - 1)
                const showPagination = Boolean(parseInt(pagination))
                if (showPagination) {
                    this.moreBtnWrapper.show()
                } else {
                    this.moreBtnWrapper.hide()
                }
                // Turn off loading
                this.setLoading(false)
                // Set Category Label
                $(`.news-and-awards-hero__category > a[data-term-id="${termID}"]`).parent().addClass('active').siblings().removeClass('active')
                // Append posts
                if (page > 1) {
                    $(this.postsBlockWrapper).append(result.slice(0, -1))
                } else {
                    $(this.postsBlockWrapper).html(result.slice(0, -1))
                    // Smooth scroll
                    // $('html, body').animate({
                    //     scrollTop: $(this.postsBlockWrapper).offset().top - $('.main-header').outerHeight() - 20
                    // }, 400)
                }
                // Set posts wrapper attributes
                $(this.postsBlockWrapper).attr('data-page', page).attr('data-term-id', termID)
            },
            error: () => {
                this.setLoading(false)
            }
        })
    }
    setLoading(status = true) {
        if (status) {
            this.postsBlock.addClass('loading')
            $(this.links).addClass('loading')
        } else {
            this.postsBlock.removeClass('loading')
            $(this.links).removeClass('loading')
        }
    }
}
export default new AwardsArchive()